import { ReactNode } from 'react'
import { Alert } from 'antd'

import Link from '~/core/Link'
import { HELP_EMAIL } from '~/lib/emailAndUrls'
import { mailtoLink } from '~/lib/mailtoLink'

const NEW_PASSWORD_TYPE = 'newPassword'
const LOCKEDOUT_TYPE = 'lockedOut'
const MFA_TYPE = 'mfa'

interface MessagesType {
    [key: string]: ReactNode
}

const newPasswordMessage = (placement: string) => (
    <>
        There was an issue creating a new password for this account. Please
        contact us at{' '}
        <Link
            href={mailtoLink(
                HELP_EMAIL,
                'Issue creating a new password for my account',
            )}
            name={HELP_EMAIL}
            placement={placement}
        >
            {HELP_EMAIL}
        </Link>
        .
    </>
)

const mfaMessage = () => (
    <>
        The following verification code is incorrect or has expired. Please try
        inputting the code again or refreshing this page to log back into your
        account.
    </>
)

const lockedOutMessage = () => <>The user is locked out</>

export default function IncorrectInputAlert(props: {
    type: typeof NEW_PASSWORD_TYPE | typeof MFA_TYPE | typeof LOCKEDOUT_TYPE
    errorMsg?: string
    placement: string
}) {
    const { placement, type } = props

    const messages: MessagesType = {
        [NEW_PASSWORD_TYPE]: newPasswordMessage(placement),
        [MFA_TYPE]: mfaMessage(),
        [LOCKEDOUT_TYPE]: lockedOutMessage(),
    }

    return (
        <Alert
            message={messages[type]}
            type="error"
            showIcon
            style={{ marginBottom: '40px', width: '100%' }}
        />
    )
}
